import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./ComparisonTable.css";
import eslipinLogo from "/public/eslipin-logo-table.svg";

const ROWS = [
  {
    id: "comision",
    label: "Comisión para anfitriones",
    type: "value",
    eslipin: { value: "0%", tone: "positive" },
    internacionales: { value: "15% a 20%", tone: "negative" },
    marketplace: { value: "0%", tone: "positive" },
  },
  {
    id: "qr",
    label: "Pago con QR Boliviano",
    type: "boolean",
    eslipin: true,
    internacionales: false,
    marketplace: false,
  },
  {
    id: "tarjeta",
    label: "Necesidad de tarjeta en dólares",
    type: "value",
    eslipin: { value: "No", tone: "positive" },
    internacionales: { value: "Si", tone: "negative" },
    marketplace: { value: "No", tone: "positive" },
  },
  {
    id: "huespedes",
    label: "Huéspedes verificados",
    type: "boolean",
    eslipin: true,
    internacionales: true,
    marketplace: false,
  },
  {
    id: "soporte",
    label: "Soporte humano en español",
    type: "boolean",
    eslipin: true,
    internacionales: false,
    marketplace: false,
  },
  {
    id: "procesos",
    label: "Procesos de reserva claros",
    type: "boolean",
    eslipin: true,
    internacionales: true,
    marketplace: false,
  },
  {
    id: "pago-seguro",
    label: "Sistema de pago seguro",
    type: "boolean",
    eslipin: true,
    internacionales: true,
    marketplace: false,
  },
];

function CheckIcon() {
  return (
    <svg
      className={s["eh-icon-check"]}
      viewBox="0 0 24 24"
      width="32"
      height="28"
      fill="none"
      stroke="#00C987"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="4 13 9 18 20 6" />
    </svg>
  );
}

function CrossIcon() {
  return (
    <svg
      className={s["eh-icon-cross"]}
      viewBox="0 0 24 24"
      width="28"
      height="28"
      fill="none"
      stroke="#BC3A2B"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="19" y1="5" x2="5" y2="19" />
      <line x1="5" y1="5" x2="19" y2="19" />
    </svg>
  );
}

function ComparisonTable() {
  return (
    <section className={s["eh-comparison"]} id="mas-informacion">
      <div className={s["eh-comparison__container"]}>
        <h2 className={s["eh-comparison__heading"]}>
          ¿Por qué elegir Eslipin?
        </h2>

        <div className={s["eh-comparison__card"]}>
          <div className={s["eh-table"]} role="table">
            {/* Header Row */}
            <div className={s["eh-table__header-row"]} role="row">
              <div
                className={`${s["eh-table__cell"]} ${s["eh-table__cell--label-head"]}`}
                role="columnheader"
              />

              <div
                className={`${s["eh-table__cell"]} ${s["eh-table__cell--eslipin"]} ${s["eh-table__cell--brand"]}`}
                role="columnheader"
              >
                <div className={s["eh-brand-header"]}>
                  <img
                    src={eslipinLogo}
                    alt="eslipin"
                    className={s["eh-brand-logo"]}
                  />
                </div>
              </div>

              <div
                className={`${s["eh-table__cell"]} ${s["eh-table__cell--internacionales"]} ${s["eh-table__cell--header"]}`}
                role="columnheader"
              >
                <span>
                  Otras plataformas
                  <br />
                  internacionales
                </span>
              </div>

              <div
                className={`${s["eh-table__cell"]} ${s["eh-table__cell--marketplace"]} ${s["eh-table__cell--header"]}`}
                role="columnheader"
              >
                <span>Marketplace</span>
              </div>
            </div>

            {/* Data Rows */}
            {ROWS.map((row) => (
              <div className={s["eh-table__row"]} role="row" key={row.id}>
                {/* Feature Label */}
                <div
                  className={`${s["eh-table__cell"]} ${s["eh-table__cell--label"]}`}
                  role="rowheader"
                >
                  {row.label}
                </div>

                {/* Eslipin Column */}
                <div
                  className={`${s["eh-table__cell"]} ${s["eh-table__cell--eslipin"]} ${s["eh-table__cell--data"]}`}
                  role="cell"
                >
                  {row.type === "boolean" ? (
                    row.eslipin ? <CheckIcon /> : <CrossIcon />
                  ) : (
                    <span
                      className={`${s["eh-val"]} ${s[`eh-val--${row.eslipin.tone}`]}`}
                    >
                      {row.eslipin.value}
                    </span>
                  )}
                </div>

                {/* Otras Plataformas Column */}
                <div
                  className={`${s["eh-table__cell"]} ${s["eh-table__cell--internacionales"]} ${s["eh-table__cell--data"]}`}
                  role="cell"
                >
                  {row.type === "boolean" ? (
                    row.internacionales ? <CheckIcon /> : <CrossIcon />
                  ) : (
                    <span
                      className={`${s["eh-val"]} ${s[`eh-val--${row.internacionales.tone}`]}`}
                    >
                      {row.internacionales.value}
                    </span>
                  )}
                </div>

                {/* Marketplace Column */}
                <div
                  className={`${s["eh-table__cell"]} ${s["eh-table__cell--marketplace"]} ${s["eh-table__cell--data"]}`}
                  role="cell"
                >
                  {row.type === "boolean" ? (
                    row.marketplace ? <CheckIcon /> : <CrossIcon />
                  ) : (
                    <span
                      className={`${s["eh-val"]} ${s[`eh-val--${row.marketplace.tone}`]}`}
                    >
                      {row.marketplace.value}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default withStyles(s)(ComparisonTable);

